var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTri2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 79,
    viewBox: "0 0 39 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_4251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1807 18.2266L30.8723 47.2935L-0.0376728 78.2035L-14.7273 49.1346L16.1807 18.2266Z",
    fill: "#E1FF8F",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.7273 49.1345L-0.0376735 78.2034L-33.4922 32.1066L-14.7273 49.1345Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1807 18.2263L-14.7273 49.1343L-33.4922 32.1064L16.1807 18.2263Z",
    fill: "#A6F200",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_4251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.3144,
    height: 56.4819,
    fill: "white",
    transform: "translate(-40 38.4062) rotate(-45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTri2Mobile);
export default __webpack_public_path__ + "static/media/tri2mobile.4dd6b2666a611e2e6370823dbba70d90.svg";
export { ForwardRef as ReactComponent };